const lang = {
    en: {
        CHECK_YOUR_INBOX: `Check your inbox and click the link to confirm your subscription`,
        EMAIL: `Email`,
        ENTER_VALID_EMAIL: `Please enter a valid email address`,
        GREAT: `Great`,
        SUBSCRIBE: `Subscribe`,
        SUBSCRIBE_OVERLAY: `Stay up to date! Get all the latest & greatest posts delivered straight to your inbox`,
        SUBSCRIBE_SECTION: `Get the latest posts delivered right to your inbox`,
        SUBSCRIBE_TO: `Subscribe to`,
        SUBSCRIBED_FAILED: `Could not sign up! Invalid sign up link.`,
        SUBSCRIBED_TO: `You've successfully subscribed to`,
        YOUR_EMAIL: `youremail@example.com`,
    },
    de: {
        CHECK_YOUR_INBOX: `Öffne dein Postfach und klicke auf den Bestätigungs-Link`,
        EMAIL: `Email`,
        ENTER_VALID_EMAIL: `Bitte eine richtige Email Adresse eingeben`,
        GREAT: `Super`,
        SUBSCRIBE: `Anmelden`,
        SUBSCRIBE_OVERLAY: `Bleib auf dem Laufenden! Erhalte die neuesten Artikel direkt in dein Postfach`,
        SUBSCRIBE_SECTION: `Erhalte die neuesten Artikel direkt in dein Postfach`,
        SUBSCRIBE_TO: `Abboniere`,
        SUBSCRIBED_FAILED: `Anmeldung gescheitert! Ungültiger Anmeldelink.`,
        SUBSCRIBED_TO: `Du hast dich erfolgreich angemeldet bei`,
        YOUR_EMAIL: `deinemail@example.de`,
    },
	ru: {
        CHECK_YOUR_INBOX: `Проверьте свой почтовый ящик и нажмите на ссылку, чтобы подтвердить подписку`,
        EMAIL: `Email`,
        ENTER_VALID_EMAIL: `Пожалуйста, введите действительный адрес электронной почты`,
        GREAT: `Отлично`,
        SUBSCRIBE: `Подписка`,
        SUBSCRIBE_OVERLAY: `Будьте в курсе! Получайте все самые свежие и лучшие сообщения прямо на ваш почтовый ящик`,
        SUBSCRIBE_SECTION: `Получайте самые свежие сообщения прямо на ваш почтовый ящик`,
        SUBSCRIBE_TO: `Подписаться на`,
        SUBSCRIBED_FAILED: `Не удалось зарегистрироваться! Неверная ссылка для регистрации.`,
        SUBSCRIBED_TO: `Вы успешно подписались на`,
        YOUR_EMAIL: `youremail@example.com`,
    },
}

module.exports = lang
